import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SessionStorage } from '@df/browser/storage/decorator/session-storage';
import { routeOverride } from '@df/core/meta/route-override.pipe';
import { Customer } from '@df/session/api/customer';

@Injectable({
    providedIn: 'root'
})
export class NeedLoginService {
    /**
     * Angular router
     */
    private router = inject(Router);

    /**
     * Session storaged email address
     */
    @SessionStorage('firstLogin')
    firstLogin?: boolean;
    /**
     * Buffer for function to be called after logging in
     */
    private needLoginCallback: (() => any) | undefined;

    constructor(readonly customer: Customer) {
        customer.model.obs.status.subscribe(() => this.onCustomerUpdate());
    }

    /**
     * If customer is logged in then performs callback immediately
     * otherwise redirect to login page and calls callback after successful login
     *
     * @todo  when customer leaves login page wihtout loging in we should drop callback
     *
     * @see  onCustomerUpdate
     * @param  {Function} callback
     */
    needLogin(callback: () => any): void {
        if (this.customer.model.isLoggedIn) {
            callback();
        } else {
            this.needLoginCallback = callback;
            this.onNeedLoginAction();
        }
    }

    onNeedLoginAction(): void {
        this.router.navigateByUrl(routeOverride('/login'));
    }

    clearNeedLogin(): void {
        this.needLoginCallback = undefined;
    }

    /**
     * Called when customer data is loaded
     * @see  needLogin
     */
    private onCustomerUpdate(): void {
        if (this.needLoginCallback) {
            if (this.customer.model.isLoggedIn) {
                this.needLoginCallback();
            }
            this.needLoginCallback = undefined;
        }
    }
}
